import {
	type BillingRangeType,
	useBillingUsageRange,
} from "@/components/providers/billing-usage-range";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import {
	getBillingRangeLabel,
	handleUsageRangeValueChange,
} from "@/lib/billing-usage";
import { cn } from "@/lib/utils";

type UsageRangeControlsProps = {
	className?: string;
};

export function UsageRangeControls({ className }: UsageRangeControlsProps) {
	const { range, setRange, start, end, setStart, setEnd } =
		useBillingUsageRange();

	return (
		<div className={cn("flex flex-col gap-3", className)}>
			<Select
				value={range}
				onValueChange={(v) => {
					if (v != null) handleUsageRangeValueChange(v, setRange);
				}}
			>
				<SelectTrigger className="h-11 w-full max-sm:text-base sm:h-9 sm:w-[200px]">
					<SelectValue>{getBillingRangeLabel(range)}</SelectValue>
				</SelectTrigger>
				<SelectContent>
					<SelectItem value="current">Current period</SelectItem>
					<SelectItem value="previous">Previous period</SelectItem>
					<SelectItem value="custom">Custom range</SelectItem>
				</SelectContent>
			</Select>
			{range === "custom" && (
				<div className="flex flex-col gap-3 sm:flex-row sm:gap-2">
					<div className="min-w-0 flex-1">
						<Label className="mb-1.5 block text-base/7 text-muted-foreground sm:text-sm/6">
							Start date
						</Label>
						<Input
							type="date"
							value={start ?? ""}
							onChange={(e) => setStart(e.target.value || null)}
							className="h-11 max-sm:text-base sm:h-9"
						/>
					</div>
					<div className="min-w-0 flex-1">
						<Label className="mb-1.5 block text-base/7 text-muted-foreground sm:text-sm/6">
							End date
						</Label>
						<Input
							type="date"
							value={end ?? ""}
							onChange={(e) => setEnd(e.target.value || null)}
							className="h-11 max-sm:text-base sm:h-9"
						/>
					</div>
				</div>
			)}
		</div>
	);
}

export type { BillingRangeType };
